import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const load = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => load("esther_cart", []));
  const [wishlist, setWishlist] = useState(() => load("esther_wishlist", []));
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("esther_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("esther_wishlist", JSON.stringify(wishlist)); }, [wishlist]);

  const lineKey = (p, size, color) => `${p.slug}|${size || ""}|${color || ""}`;

  const addItem = useCallback((product, { size, color, quantity = 1 } = {}) => {
    setItems((prev) => {
      const key = lineKey(product, size, color);
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + quantity } : i);
      return [...prev, {
        key, product_id: product.id, slug: product.slug, name: product.name,
        price: product.price, image: product.images?.[0], size: size || null,
        color: color || null, quantity,
      }];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((key, qty) => {
    setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, qty) } : i));
  }, []);

  const removeItem = useCallback((key) => setItems((prev) => prev.filter((i) => i.key !== key)), []);
  const clearCart = useCallback(() => setItems([]), []);

  const toggleWishlist = useCallback((slug) => {
    setWishlist((prev) => prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug]);
  }, []);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{
      items, wishlist, open, setOpen, addItem, updateQty, removeItem, clearCart,
      toggleWishlist, subtotal, count,
    }}>
      {children}
    </CartContext.Provider>
  );
};
